import React from "react";
import { OrgAppSettingsContext } from "./OrgAppSettingsProvider";

export default function useOrgAppSettings() {
    return React.useContext(OrgAppSettingsContext);
}